import { alpha, styled } from '@mui/material';
import { memo } from 'react';
import { formatDateDivider } from '../utils/formatDateDivider';

type ChatMessageDateDividerProps = {
  date: string;
};

export const ConversationMessageDateDivider = memo(
  ({ date }: ChatMessageDateDividerProps) => (
    <StyledContainer>
      <StyledLine />
      <StyledLabel>{formatDateDivider(date)}</StyledLabel>
      <StyledLine />
    </StyledContainer>
  ),
);

const StyledContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledLabel = styled('p')(({ theme }) => ({
  ...theme.typography.subtitle2,
  margin: 0,
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.divider, 0.08),
}));

const StyledLine = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  height: '1px',
  flexGrow: 1,
}));
